import './ProcessingModal.css';

import InstallButton from './InstallButton';

const processingMessages = [
  { icon: '📖', text: 'Reading your menu...' },
  { icon: '🔍', text: 'Finding dishes...' },
  { icon: '🎨', text: 'Preparing images and nutrition...' },
  { icon: '🍽️', text: 'Results will appear automatically.' },
];

const ProcessingModal = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="processing-modal-overlay">
      <div className="processing-modal">
        <div className="processing-messages-container">
          <div className="processing-messages-list">
            <span>
              Install the app clicking <InstallButton />
            </span>
            {processingMessages.map((message, index) => (
              <div key={message.text} className="processing-message-item" style={{ animationDelay: `${index * 120}ms` }}>
                <span className="processing-message-icon">{message.icon}</span>
                <span className="processing-message-text">{message.text}</span>
              </div>
            ))}
          </div>
          <div className="processing-progress-bar">
            <div className="processing-progress-fill"></div>
          </div>
          <div className="processing-status-text">Processing menu...</div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingModal;
